/**
 * Configuration constants for ReconnectionDialog
 */
export const RECONNECTION_CONFIG = {
  MAX_ATTEMPTS: 5,
  COUNTDOWN_SECONDS: 10,
  SUCCESS_DELAY_MS: 1000,
  RETRY_DELAY_MS: 100,
  DIALOG_WIDTH: '500px',
  ARIA_LABELS: {
    DIALOG: 'Reconexión automática',
    PROGRESS: 'Progreso de reconexión',
    SUCCESS: 'Conexión exitosa',
    ERROR: 'Error de conexión',
    RETRY: 'Reintentar conexión',
    CLOSE: 'Cerrar diálogo'
  }
};

/**
 * Reconnection states
 */
export const RECONNECTION_STATES = {
  IDLE: 'idle',
  RECONNECTING: 'reconnecting',
  SUCCESS: 'success',
  FAILED: 'failed',
  MANUAL: 'manual'
};

/**
 * Error types for better error handling
 */
export const ERROR_TYPES = {
  CONNECTION_FAILED: 'CONNECTION_FAILED',
  TIMEOUT: 'TIMEOUT',
  ABORTED: 'ABORTED',
  UNKNOWN: 'UNKNOWN'
};
